module.exports = "https://static.wmbcdn.com/uniweb/images/dccb23d23ecc310ede8db5acfb78eecd.svg";